module.exports = __webpack_public_path__ + "img/logo 2.96f9845d.png";